import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'messenger',

        getMessages(params = null) {
            return ApiService.get(`/${this.resource}/messages`, params);
        },

        getUnreadNotifications(params = null) {
            return ApiService.get(`/${this.resource}/unread-notifications`, params);
        },

        getNotificationSender(userID, params = null) {
            return ApiService.get(`/${this.resource}/get-notification-sender/${userID}`, params);
        },

        requestChat(data) {
            return ApiService.post(`/${this.resource}/request-chat`, data);
        },

        sendMessage(data) {
            return ApiService.post(`/${this.resource}/send-message`, data);
        },

        uploadFile(data) {
            return ApiService.post(`/${this.resource}/upload`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
        },

        getLastMsgForEachParent(data) {
            return ApiService.post(`/${this.resource}/get-last-msg-for-each-parent`, data);
        },
    }
}